// @flow
import React from 'react';
import Checkbox from 'app/common/ui/Checkbox';
import WithHOC from 'app/common/components/WithHOC';
import CheckboxSettings from 'app/containers/Settings/Checkbox';
import SettingsGear from 'app/common/components/Settings';
import styles from './OrgsDishes.scss';


export type DishesTableSettings = {
  rows: number,
  title: boolean,
  photo: boolean,
  portion: boolean,
  cost: boolean,
  saleType: boolean,
  category: boolean,
  setup: boolean,
};

const OrgsDishesGear = () => (<SettingsGear dataKey="orgsDishes">
  {({ saveSettings }) => (<div>
    <div className={styles.gearHeader}>{'Столбцы:'}</div>
    {/* Чекбоксы в настройках */}
    <WithHOC
      component={Checkbox}
      hoc={CheckboxSettings}
      label="Фото"
      name="photo"
      saveSettings={saveSettings}
      className={styles.gearCheck}
      settingsKey="orgsDishes"
    />
    <WithHOC
      component={Checkbox}
      hoc={CheckboxSettings}
      label="Порция"
      name="portion"
      saveSettings={saveSettings}
      className={styles.gearCheck}
      settingsKey="orgsDishes"
    />
    <WithHOC
      component={Checkbox}
      hoc={CheckboxSettings}
      label="Стоимость"
      name="cost"
      saveSettings={saveSettings}
      className={styles.gearCheck}
      settingsKey="orgsDishes"
    />
    <WithHOC
      component={Checkbox}
      hoc={CheckboxSettings}
      label="Тип продукции"
      name="saleType"
      saveSettings={saveSettings}
      className={styles.gearCheck}
      settingsKey="orgsDishes"
    />
    <WithHOC
      component={Checkbox}
      hoc={CheckboxSettings}
      label="Категория"
      name="category"
      saveSettings={saveSettings}
      className={styles.gearCheck}
      settingsKey="orgsDishes"
    />
    <WithHOC
      component={Checkbox}
      hoc={CheckboxSettings}
      label="Действия"
      name="setup"
      saveSettings={saveSettings}
      className={styles.gearCheck}
      settingsKey="orgsDishes"
    />
  </div>)}
</SettingsGear>);

export default OrgsDishesGear;
